import Vue from 'vue'
import Router from 'vue-router'
import frame from '@/pages/frame'
import home from '@/pages/home'
import appointView from '@/pages/appointView'
import message from '@/pages/message'
import personalData from '@/pages/personalData'
import modifyPersonalData from '@/pages/modifyPersonalData'
import login from '@/pages/login'
import visitorConGuide from '@/pages/visitorConGuide'
import appointStep1 from '@/pages/appointStep1'
import appointStep2 from '@/pages/appointStep2'
import fillPreQuiz from '@/pages/fillPreQuiz'
import fillPreQuiz2 from '@/pages/fillPreQuiz2'
import fillPreQuiz3 from '@/pages/fillPreQuiz3'
import appointReserve from '@/pages/appointReserve'
import appointFinished from '@/pages/appointFinished'
import appointWait from '@/pages/appointWait'
import appointCancel from '@/pages/appointCancel'
import appointSuccess from '@/pages/appointSuccess'
import quest from '@/pages/quest'
import questFinish from '@/pages/questFinish'
import questIntro from '@/pages/questIntro'
import questCenter from '@/pages/questCenter'
import questAssign from '@/pages/questAssign'

import go from '@/pages/go'
import goByStudentId from '@/pages/goByStudentId'
import error from '@/pages/error'
import casLogin from '@/pages/casLogin'

import test from '@/pages/Test'
import smartPavilion from '@/pages/smartPavilion.vue'
import smartPavilionDetails from '@/pages/smartPavilionDetails.vue'
import pavilionAppoint from '@/pages/pavilionAppoint.vue'
import pavilionAppointDetails from '@/pages/pavilionAppointDetails.vue'


import allApplication from '@/pages/allApplication.vue'
import aiConsult from '@/pages/aiConsult.vue'

import customerService from '@/pages/customerService.vue'
import loginByStudentId from '@/pages/loginByStudentId'
Vue.use(Router)
// 解决重复点击相同路由报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: "history",
  base: '/constu/',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    }, {
      path: '/loginByStudentId',
      name: 'loginByStudentId',
      component: loginByStudentId
    }, {
      path: '/customerService',
      name: 'customerService',
      component: customerService
    }, {
      path: '/go',
      name: 'go',
      component: go
    }, {
      path: '/goByStudentId',
      name: 'goByStudentId',
      component: goByStudentId
    }, {
      path: '/error',
      name: 'error',
      component: error
    }, {
      path: '/casLogin',
      name: 'casLogin',
      component: casLogin
    }, {
      path: '/test',
      name: 'test',
      component: test
    }, {
      path: '/firstPersonalData',
      name: 'firstPersonalData',
      component: modifyPersonalData,
    }, {
      path: '/simpleQuest',
      name: 'simpleQuest',
      component: quest,
    }, {
      path: '/simpleQuestFinish',
      name: 'simpleQuestFinish',
      component: questFinish,
    }, {
      path: '/simpleQuestIntro',
      name: 'simpleQuestIntro',
      component: questIntro,
    }, {
      path: '/',
      name: 'frame',
      component: frame,
      redirect: "home",
      children: [{
        path: '/home',
        name: 'home',
        component: home,
      }, {
        path: '/appointView',
        name: 'appointView',
        component: appointView,
      }, {
        path: '/message',
        name: 'message',
        component: message,
      }, {
        path: '/personalData',
        name: 'personalData',
        component: personalData,
      }, {
        path: '/modifyPersonalData',
        name: 'modifyPersonalData',
        component: modifyPersonalData,
      }, {
        path: '/visitorConGuide',
        name: 'visitorConGuide',
        component: visitorConGuide,
      }, {
        path: '/appointStep1',
        name: 'appointStep1',
        component: appointStep1,
      }, {
        path: '/appointStep2',
        name: 'appointStep2',
        component: appointStep2,
      }, {
        path: '/fillPreQuiz',
        name: 'fillPreQuiz',
        component: fillPreQuiz,
      }, {
        path: '/fillPreQuiz2',
        name: 'fillPreQuiz2',
        component: fillPreQuiz2,
      }, {
        path: '/fillPreQuiz3',
        name: 'fillPreQuiz3',
        component: fillPreQuiz3,
      }, {
        path: '/appointReserve',
        name: 'appointReserve',
        component: appointReserve,
      }, {
        path: '/appointFinished',
        name: 'appointFinished',
        component: appointFinished,
      }, {
        path: '/appointWait',
        name: 'appointWait',
        component: appointWait,
      }, {
        path: '/appointCancel',
        name: 'appointCancel',
        component: appointCancel,
      }, {
        path: '/appointSuccess',
        name: 'appointSuccess',
        component: appointSuccess,
      }, {
        path: '/quest',
        name: 'quest',
        component: quest,
      }, {
        path: '/questFinish',
        name: 'questFinish',
        component: questFinish,
      }, {
        path: '/questIntro',
        name: 'questIntro',
        component: questIntro,
      }, {
        path: '/questCenter',
        name: 'questCenter',
        component: questCenter,
      }, {
        path: '/questAssign',
        name: 'questAssign',
        component: questAssign,
      }, {
        path: '/pavilionAppoint',
        name: 'pavilionAppoint',
        component: pavilionAppoint,
      }, {
        path: '/pavilionAppointDetails',
        name: 'pavilionAppointDetails',
        component: pavilionAppointDetails,
      }, {
        path: '/smartPavilion',
        name: 'smartPavilion',
        component: smartPavilion,
      }, {
        path: '/smartPavilionDetails',
        name: 'smartPavilionDetails',
        component: smartPavilionDetails,
      }, {
        path: '/allApplication',
        name: 'allApplication',
        component: allApplication,
      }, {
        path: '/aiConsult',
        name: 'aiConsult',
        component: aiConsult,
        meta: { hideFooter: true }
      }]
    }
  ]
})
